import { CircularProgress, Container, Stack } from "@mui/material";
import { auth, db, functions } from "../firebase.config";
import { signInWithCustomToken } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Variables } from "../context/VariableContext";
import { UserAuth } from "../context/AuthContext";

const Authenticate = () => {
    const { user, logIn, signUpSecondStep, logOut, forgotPass, handleFacebookSigin, faceSecondStep } = UserAuth();
    const { openLogin, setOpenLogin } = Variables();
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);



    React.useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');

        const verifyToken = async () => {
            console.log(token);
            if (!token) {
                alert("Lien invalide");
                navigate("/login", { replace: true }); // Rediriger vers la page de scan
                return;
            }
            const linkRef = doc(db, "authLinks", token);
            const linkSnap = await getDoc(linkRef);
            if (!linkSnap.exists()) {
                alert("Lien non valide");
                navigate("/login", { replace: true }); // Rediriger vers la page de scan
                return;
            }
            
            console.log(linkSnap.data())
            const { uid, isActive } = linkSnap.data();
            /*if (!isActive) {
                alert("Ce lien est inactif");
                return;
            }*/
            try {
                // Simuler l'authentification avec un token Firebase
                const generateCustomToken = httpsCallable(functions, "generateCustomToken");
                const response = await generateCustomToken({
                    uid
                });
                const customToken = response.data.customToken
                if (customToken != null) {
                    signInWithCustomToken(auth, customToken)
                        .then(async () => {
                            navigate("/onboarding", { replace: true }); // Rediriger vers la page de scan
                        })
                        .catch((error) => {
                            console.error("Erreur d'authentification:", error);
                            navigate("/login", { replace: true }); // Rediriger vers la page de scan
                        });
                }

            } catch (error) {
                console.error(error)
            }

        };

        verifyToken();
    }, [db, user]);



    return (
        <Container>
            <Stack justifyContent='center' alignItems='center' spacing={1} sx={{ color: 'white' }}>
                <CircularProgress sx={{ width: 50, height: 50 }} />
            </Stack>

        </Container>
    );
};

export default Authenticate;